// Haversine formula for calculating distance between two coordinates
export function getDistanceMiles(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 3958.8; // Earth's radius in miles
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function toRad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * Radius meaning "don't drop anything for being far away".
 *
 * A zip code is two requests in one — where am I, and how far will I go — and
 * they are worth separating. Someone who wants the whole calendar ordered by
 * what is closest, rather than a 25-mile slice of it, picks this.
 */
export const ANY_DISTANCE = 0;

export const DISTANCE_OPTIONS = [
  { value: 5, label: "5 miles" },
  { value: 10, label: "10 miles" },
  { value: 25, label: "25 miles" },
  { value: 50, label: "50 miles" },
  { value: 100, label: "100 miles" },
  { value: ANY_DISTANCE, label: "Any distance" },
] as const;

const VALID_DISTANCES = new Set<number>(DISTANCE_OPTIONS.map((o) => o.value));

/** Whether `value` is one of the radii the picker offers. */
export function isValidDistance(value: number): boolean {
  return VALID_DISTANCES.has(value);
}

/**
 * How far away a venue reads on a card.
 *
 * Under ten miles the tenth matters — 0.4 and 4 miles are a walk and a drive —
 * and past that it is noise.
 */
export function formatDistanceMiles(miles: number): string {
  const rounded = miles < 10 ? Math.round(miles * 10) / 10 : Math.round(miles);
  return `${rounded} mi`;
}
